import { _WEB_VERSION } from './constant';
// export const _BASE_URL = 'http://localhost:5002'; // Stage
export const _BASE_URL = 'https://api.fipays.com'; // Production

const Routes = {
    _INIT_TRANSACTION:  "/transaction/portal-init",
    _GET_TRANSACTION: "/transaction/detail",
    _VALIDATE_TRANSACTION: "/transaction/validate",
    _CALLBACK: "/transaction/callback"
};

export default Routes;
